<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">

      <Form ref="ruleSetForm" @submit="addRuleset" :validation-schema="rulesetSchema">
        <div class="row">

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Code <span class="text-danger">*</span>
              </label>
              <Field name="code" v-slot="{ value, handleChange }">
                <Multiselect :modelValue="value" @update:modelValue="handleChange" :options="ruleSetCodeOptions"
                  label="label" track-by="value" valueProp="value"
                  placeholder="Sélectionner le code du jeu de règles" />
              </Field>
              <ErrorMessage name="code" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Libelle <span class="text-danger">*</span>
              </label>
              <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le libelle" />
              <ErrorMessage name="name" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
              <Field name="description" as="textarea" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Description..." />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type de périmètre ciblé <span class="text-danger">*</span>
              </label>
              <Field name="scope_type" v-slot="{ value, handleChange }">
                <Multiselect :modelValue="value" @update:modelValue="handleChange" :options="scopeTypeOptions"
                  label="label" track-by="value" valueProp="value" placeholder="Sélectionner le périmètre" />
              </Field>

            </div>
          </div>
          <div class="col-md-6">
            <label class="d-block text-black fw-semibold mb-10">
              Priorité d’exécution
            </label>

            <Field name="priority" v-slot="{ value, handleChange }">
              <Multiselect :modelValue="value" @update:modelValue="handleChange" :options="priorityOptions"
                label="label" track-by="value" valueProp="value" placeholder="Sélectionner la priorité" />
            </Field>
          </div>


          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays
              </label>
              <Field name="pays" v-slot="{ field }">
                <Multiselect :options="paysOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le pays" />
              </Field>
            </div>
            <ErrorMessage name="pays" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Port
              </label>
              <Field name="port" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="ports" :searchable="true"
                  :loading="loadingPorts" placeholder="Rechercher (nomPort ou locode)..." label="label" track-by="value"
                  @search-change="searchPort" :filter-results="false" :min-chars="2" />
              </Field>
              <ErrorMessage name="port" class="text-danger" />
            </div>
          </div>
          

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date d’entrée en vigueur de ce jeu de règles.
              </label>
              <Field name="effective_from" type="date" class="form-control shadow-none fs-md-15 text-black" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de fin d’application éventuelle.
              </label>
              <Field name="effective_to" type="date" class="form-control shadow-none fs-md-15 text-black" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <label class="d-block text-black fw-semibold mb-10">
              Activer le jeu de règles
            </label>

            <Field name="is_active" type="checkbox" class="form-check-input" :value="true" :unchecked-value="false" />
          </div>


          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Ajouter la règle
              </button>
              <router-link to="/listeRuleSet" class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import axios from 'axios';
import Multiselect from '@vueform/multiselect'
import { Rule } from '@/models/Rule';
import { RuleSet } from '@/models/RuleSet';

export default defineComponent({
  name: "AddRuleSet",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const rulesetSchema = Yup.object().shape({
      code: Yup.string().required("Le code est obligatoire"),
      name: Yup.string().required("Le libellé est obligatoire"),
      description: Yup.string().required("La description est obligatoire"),
      scope_type: Yup.string().required(),
      priority: Yup.string().nullable(),
      pays: Yup.mixed().notRequired(),
      port: Yup.mixed().notRequired(),
      is_active: Yup.boolean(),

      effective_from: Yup.date().nullable(),
      effective_to: Yup.date().nullable(),
    });


    const ruleSetForm = ref<RuleSet | null>(null);
    const paysOptions = ref([]);
    const ports = ref<{ value: number; label: string }[]>([]);
    const loadingPorts = ref(false);
    let searchTimeout: ReturnType<typeof setTimeout> | null = null;
    const router = useRouter();

    const scopeTypeOptions = [
      { value: 'GLOBAL', label: 'Global' },
      { value: 'COUNTRY', label: 'Pays' },
      { value: 'PORT', label: 'Port' },
      { value: 'REGIME', label: 'Régime douanier' },
      { value: 'PRODUCT_CATEGORY', label: 'Catégorie de produit' },
    ];

    const priorityOptions = [
      { value: 'LOW', label: 'Faible' },
      { value: 'MEDIUM', label: 'Moyenne' },
      { value: 'HIGH', label: 'Élevée' },
    ];

        const ruleSetCodeOptions = [
      { value: 'BESC_CORE', label: 'Règles générales BESC' },
      { value: 'TG_BESC_CORE', label: 'Règles specfique BESC Togo' },
      { value: 'TJ_IMPORT_RULES', label: 'Règles Import – Togo' },
      { value: 'HIGH_VALUE_CONTROLS', label: 'Contrôles valeurs élevées' },
      { value: 'COTONOU_PORT_RULES', label: 'Règles Port de Cotonou' },
      { value: 'LOME_PORT_RULES', label: 'Règles Port de Lomé (Togo)' },
      { value: 'DOUALA_PORT_RULES', label: 'Règles Port de Douala (Cameroun)' },
      { value: 'AGRI_PRODUCT_RULES', label: 'Règles Produits agricoles et alimentaires' },
      { value: 'PHARMA_CHEM_RULES', label: 'Règles Produits pharmaceutiques et chimiques' },
    ];



    const fetchPays = async () => {
      try {
        const response = await ApiService.get('/pays');
        const paysData = response.data.data.data;
        console.log("paysDataaaa", paysData);
        paysOptions.value = paysData.map((p) => ({
          value: p.id,
          label: `${p.name_fr}`,
        }));
      } catch (error) {
        //
      }
    };


    const searchPort = async (query: string) => {
      if (searchTimeout) clearTimeout(searchTimeout);

      if (!query || query.length < 2) {
        ports.value = [];
        return;
      }

      searchTimeout = setTimeout(async () => {
        loadingPorts.value = true;
        try {
          const response = await ApiService.get(
            `/Liste/port?search=${encodeURIComponent(query)}`
          );
          const portsData = response.data?.data || [];

          ports.value = portsData.map((port: any) => ({
            label: `${port.nomPort} - ${port.locode}`,
            value: port.id,
          }));
        } catch (err) {
          console.error('Erreur recherche ports:', err);
          ports.value = [];
        } finally {
          loadingPorts.value = false;
        }
      }, 300);
    };


    const addRuleset = async (values, { resetForm }) => {
      const dataToSend = {
        ...values,
        is_active: values.is_active ?? false,

      };
      console.log("dodo", dataToSend);
      ApiService.post("/ruleset", dataToSend)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeRuleSetPage" });
          }
        }).catch(({ response }) => {
          error(response.data.message);
        });
    };



    onMounted(() => {
      fetchPays();
    })
    return {
      addRuleset,
      rulesetSchema,
      ruleSetForm,
      paysOptions,
      ports,
      loadingPorts,
      searchPort,
      scopeTypeOptions,
      priorityOptions,
      ruleSetCodeOptions
    };
  },
});
</script>